// extracted by mini-css-extract-plugin
export var link = "_h-0";